import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import jwtDecode from 'jwt-decode';

const routes = [
  // авторизация
  {
    path: '/auth',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/pages/auth.vue'),
  },
  // восстановаление пароля
  {
    path: '/restore',
    name: 'Restore',
    component: () => import(/* webpackChunkName: "restore" */ '@/pages/restore/index.vue'),
  },
  // восстановаление пароля - переход из email письма
  {
    path: '/restore/confirm',
    name: 'RestoreConfirm',
    component: () => import(/* webpackChunkName: "restore-confirm" */ '@/pages/restore/confirm.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/index.vue'),
  },
  {
    path: '/confirm/success/',
    name: 'ConfirmSuccess',
    component: () => import('@/pages/confirm/ConfirmSuccess.vue'),
  },
  {
    path: '/confirm/fail/',
    name: 'ConfirmFail',
    component: () => import('@/pages/confirm/ConfirmFail.vue'),
  },

  // регистрация
  {
    path: '/registration',
    name: 'Registration',
    component: () => import(/* webpackChunkName: "registration" */ '@/pages/registration/registration.vue'),
  },
  // регистрация v2024
  {
    path: '/registration/process',
    name: 'RegistrationProcess',
    component: () => import(/* webpackChunkName: "registrationProcess" */ '@/pages/registration/registrationProcess.vue'),
  },
  // регистрация заказчика v2024
  {
    path: '/registration/customer',
    name: 'RegistrationCustomer',
    component: () => import(/* webpackChunkName: "registrationProcess" */ '@/pages/registration/registrationCustomer.vue'),
  },
  {
    path: '/registration/success',
    name: 'RegistrationSuccess',
    component: () => import(
      /* webpackChunkName: "registrationSuccess" */ '@/pages/registration/registrationSuccess.vue'
    ),
  },
  {
    path: '/registration/error',
    name: 'RegistrationError',
    component: () => import(
      /* webpackChunkName: "registrationError" */ '@/pages/registration/registrationError.vue'
    ),
  },
  // заявка на уточнение
  {
    path: '/lot/:lotId/clarification-request',
    name: 'ClarificationRequestCreate',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/supplier/request/clarification.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // Список заявок на уточнение
  {
    path: '/clarifications/',
    name: 'ClarificationsList',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/clarification/clarification-list.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('clarifications/setPage', +query.page || 1);
        store.commit('clarifications/setSearch', query.search || '');
        store.dispatch('clarifications/loadList');
      },
    },
  },
  // заявка на уточнение
  {
    path: '/clarification-request/:id',
    name: 'ClarificationRequest',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/supplier/request/clarification.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/supply-request-list/',
    name: 'SupplyRequestList',
    component: () => import('@/pages/supply-request/request-list.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('supplyRequest/setPage', +query.page || 1);
        store.commit('supplyRequest/setSearch', query.search || '');
        store.dispatch('supplyRequest/loadList');
      },
    },
  },
  // Заявка на поставку
  {
    path: '/supply-request',
    name: 'SupplyRequestCreate',
    component: () => import(/* webpackChunkName: "SupplyRequest" */ '@/pages/supply-request.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: () => {
        store.commit('supplyRequest/resetDetailsState');
      },
    },
  },
  // Заявка на поставку
  {
    path: '/supply-request/:id',
    name: 'SupplyRequest',
    component: () => import(/* webpackChunkName: "SupplyRequest" */ '@/pages/supply-request.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: () => {
        store.commit('supplyRequest/resetDetailsState');
      },
    },
  },
  // Заявка на поставку
  {
    path: '/receipt-order/:requestId',
    name: 'ReceiptOrder',
    component: () => import(/* webpackChunkName: "SupplyRequest" */ '@/pages/receipt-order.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  // Задание на поставку
  {
    path: '/supply-task-list/',
    name: 'SupplyTaskList',
    component: () => import('@/pages/supply-task/supply-task-list.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('supplyTask/setPage', +query.page || 1);
        store.commit('supplyTask/setSearch', query.search || '');
        store.dispatch('supplyTask/loadList');
      },
    },
  },

  // Заявка на поставку
  {
    path: '/supply-task/:id',
    name: 'SupplyTask',
    component: () => import(/* webpackChunkName: "SupplyRequest" */ '@/pages/supply-request.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: () => {
        store.commit('supplyRequest/resetDetailsState');
      },
    },
  },

  // Раздел помощи
  {
    path: '/help/instructions/',
    name: 'Instructions',
    component: () => import('@/pages/help/instructions.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/help/contacts/',
    name: 'Contacts',
    component: () => import('@/pages/help/contacts.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  // Договоры
  {
    path: '/constract/',
    name: 'СontractList',
    component: () => import('@/pages/contact/contract-list.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('contracts/setPage', +query.page || 1);
        store.commit('contracts/setSearch', query.search || '');
        store.dispatch('contracts/loadList');
      },
    },
  },
  {
    path: '/constract-detail/:contractID/',
    name: 'СontractDetail',
    component: () => import('@/pages/contact/contract-detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  // Протоколы
  {
    path: '/protocol/',
    name: 'ProtocolList',
    component: () => import('@/pages/protocol/protocol-list.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('protocols/setPage', +query.page || 1);
        store.commit('protocols/setSearch', query.search || '');
        store.dispatch('protocols/loadList');
      },
    },
  },
  {
    path: '/protocol-detail/:protocolID/',
    name: 'ProtocolDetail',
    component: () => import('@/pages/protocol/protocol-detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/protocol-status/',
    name: 'ProtocolStatus',
    component: () => import('@/pages/protocol/protocol-status.vue'),
    meta: {
      requiresAuth: true,
    },
  },

  // Ген план
  {
    path: '/genplan/:lotID',
    name: 'GenPlan',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/genplan.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // Детализация лота
  {
    path: '/lot/:lotID',
    name: 'Lot',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/lot.vue'),
  },
  // Заявка на участие
  {
    path: '/lot/:lotID/request',
    name: 'Request',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/request.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // Успешно подали заявку на участие
  {
    path: '/success/lot/request',
    name: 'SuccessRequest',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/request-lot-success.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // История лота
  {
    path: '/lot/:lotID/history',
    name: 'History',
    component: () => import(/* webpackChunkName: "purchaseHistory" */ '@/pages/purchase-history.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // Документы
  {
    path: '/documents',
    name: 'Documents',
    component: () => import(/* webpackChunkName: "documents" */ '@/pages/documents.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'documents');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'documents');
        store.commit('lots/setPage', +query.page || 1);
        store.commit('lots/setSearch', query.search || '');
        store.dispatch('lots/loadDocuments');
      },
    },
  },
  // Актуальные закупки
  {
    path: '/actual-purchases',
    name: 'ActualPurchases',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/actual-purchases.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'actual');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'actual');
        store.commit('lots/setPage', +query.page || 1);
        store.commit('lots/setSearch', query.search || '');
        store.dispatch('lots/loadList');
      },
    },
  },
  // Планируемые закупки
  {
    path: '/planned-purchases',
    name: 'PlannedPurchases',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/planned-purchases.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'planned');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'planned');
        store.commit('lots/setPage', +query.page || 1);
        store.commit('lots/setSearch', query.search || '');
        store.dispatch('lots/loadList');
      },
    },
  },
  // Избранные закупки
  {
    path: '/favorite-purchases',
    name: 'FavoritePurchases',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/purchases/favorite-purchases.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'favorite');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('lots/setPage', +query.page || 1);
        store.commit('lots/setSearch', query.search || '');
        store.dispatch('lots/loadFavoriteList');
      },
    },
  },
  // С моим учетом
  {
    path: '/my-purchases',
    name: 'MyPurchases',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/purchases/my-purchases.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'my');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('lots/setPage', +query.page || 1);
        store.commit('lots/setSearch', query.search || '');
        store.dispatch('lots/loadMyLotsList');
      },
    },
  },
  // Организации партнеры
  {
    path: '/organizations/partner',
    name: 'PartnerOrganizations',
    component: () => import(/* webpackChunkName: "Organizations" */ '@/pages/organizations.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'PartnerOrganizations');
        store.commit('admin/setOrganizationsPage', +query.page || 1);
        store.commit('admin/setPartnerOrganizationsSearch', query.search || '');
        store.dispatch('admin/loadPartnerList');
      },
    },
  },
  // Организации партнеры
  {
    path: '/organizations/customer',
    name: 'CustomerOrganizations',
    component: () => import(/* webpackChunkName: "Organizations" */ '@/pages/organizations.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'CustomerOrganizations');
        store.commit('admin/setOrganizationsPage', +query.page || 1);
        store.commit('admin/setPartnerOrganizationsSearch', query.search || '');
        store.dispatch('admin/loadCustomerList');
      },
    },
  },
  // Организации партнеры, детали
  {
    path: '/organizations/partner/:id',
    name: 'PartnerOrganizationDetails',
    component: () => import(/* webpackChunkName: "Organizations" */ '@/pages/organization-details/index.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'PartnerOrganizationDetails');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // Организации партнеры, детали
  {
    path: '/organizations/customer/:id',
    name: 'CustomerOrganizationDetails',
    component: () => import(/* webpackChunkName: "Organizations" */ '@/pages/organization-details/index.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'CustomerOrganizationDetails');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'CustomerOrganizationDetails');
        store.commit('admin/setOrganizationsPage', +query.page || 1);
        store.commit('admin/setCustomerOrganizationsSearch', query.search || '');
        store.dispatch('admin/loadCustomerList');
      },
    },
  },
  // Организации партнеры
  {
    path: '/objects',
    name: 'Objects',
    component: () => import(/* webpackChunkName: "Organizations" */ '@/pages/objects.vue'),
    beforeEnter: async () => {
      store.commit('appService/setFilterType', 'Objects');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'Objects');
        store.commit('admin/setObjectsPage', +query.page || 1);
        store.commit('admin/setObjectsSearch', query.search || '');
        store.dispatch('admin/loadObjectsList');
      },
    },
  },
  {
    path: '/planned-lots',
    name: 'PlannedLots',
    component: () => import(/* webpackChunkName: "PlannedLots" */ '@/pages/planned-lots/index.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.dispatch('admin/loadPlannedLots');
      },
    },
  },
  {
    path: '/material-dictionary',
    name: 'MaterialDictionary',
    component: () => import(/* webpackChunkName: "MaterialDictionary" */ '@/pages/material-dictionary/index.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.dispatch('admin/loadMaterialGuideFile');
      },
    },
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import(/* webpackChunkName: "Reports" */ '@/pages/reports/index.vue'),
    // meta: {
    //   requiresAuth: true,
    //   deserializeQuery: (query) => {
    //     store.dispatch('admin/loadMaterialGuideFile');
    //   },
    // },
  },
  // Организации партнеры, детали
  {
    path: '/organizations/partner/:id',
    name: 'PartnerOrganizationDetails',
    component: () => import(/* webpackChunkName: "Organizations" */ '@/pages/organization-details/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // Организации партнеры, детали
  {
    path: '/organizations/customer/:id',
    name: 'CustomerOrganizationDetails',
    component: () => import(/* webpackChunkName: "Organizations" */ '@/pages/organization-details/index.vue'),
    beforeEnter: async () => {
      store.commit('appService/setFilterType', 'CustomerOrganizationDetails');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // Архивные закупки
  {
    path: '/archive-purchases',
    name: 'ArchivePurchases',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/archive-purchases.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'archive');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'archive');
        store.commit('lots/setPage', +query.page || 1);
        store.commit('lots/setSearch', query.search || '');
        store.dispatch('lots/loadList');
      },
    },
  },
  // Страница подтверждения данных пользователя
  {
    path: '/confirm-data',
    name: 'ConfirmData',
    component: () => import(/* webpackChunkName: "Settings" */ '@/pages/confirm-data.vue'),
  },
  // Страница настроек пользователя
  {
    path: '/settings/user',
    name: 'UserSettings',
    component: () => import(/* webpackChunkName: "Settings" */ '@/pages/settings.vue'),
    beforeEnter: async () => {
      store.commit('appService/setFilterType', 'UserSettings');
      await store.dispatch('registration/info');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // Страница настроек организации
  {
    path: '/settings/organization',
    name: 'OrganizationSettings',
    component: () => import(/* webpackChunkName: "Settings" */ '@/pages/settings.vue'),
    beforeEnter: async () => {
      store.commit('appService/setFilterType', 'OrganizationSettings');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // Страница изменения электронной почты
  {
    path: '/settings/email',
    name: 'EmailChange',
    component: () => import(/* webpackChunkName: "Settings" */ '@/pages/settings.vue'),
    beforeEnter: async () => {
      store.commit('appService/setFilterType', 'EmailChange');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // Страница изменения пароля
  {
    path: '/settings/password',
    name: 'PasswordChange',
    component: () => import(/* webpackChunkName: "Settings" */ '@/pages/settings.vue'),
    beforeEnter: async () => {
      store.commit('appService/setFilterType', 'PasswordChange');
    },
    meta: {
      requiresAuth: true,
    },
  },

  // Список уведомлений
  {
    path: '/notifications/',
    name: 'NotificationList',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/notification/notification-list.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('notifications/setPage', +query.page || 1);
        store.commit('notifications/setSearch', query.search || '');
        store.dispatch('notifications/loadList');
      },
    },
  },
  // Детальная страница уведомления
  {
    path: '/notifications-item/:notificationID/',
    name: 'NotificationDetail',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/notification/notification-detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // Страница-заглушка
  {
    path: '/page-under-construction/',
    name: 'PageUnderConstruction',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/page-under-construction.vue'),
  },
  // Генподрядчики
  {
    path: '/gen-contractors',
    name: 'GeneralContractors',
    component: () => import(/* webpackChunkName: "GeneralContractors" */ '@/pages/gen-contractors/index.vue'),
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'GeneralContractors');
        store.commit('admin/setObjectsPage', +query.page || 1);
        store.commit('admin/setObjectsSearch', query.search || '');
        store.dispatch('admin/loadGenconctractorList');
      },
    },
  },
  // Генподрядчики детали
  {
    path: '/gen-contractors/:id',
    name: 'GeneralContractorsDetails',
    component: () => import(/* webpackChunkName: "GeneralContractorsDetails" */ '@/pages/gen-contractors/detail.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'GeneralContractorsDetails');
    },
    meta: {
      requiresAuth: true,
    },
  },
  // успешно подали заявку на генподрядчика
  {
    path: '/success/gen-contractor-register',
    name: 'SuccessGencontractorRegister',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/gen-contractors/success.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  { // список лотов на ген подряды
    path: '/gen-contractor-lots/',
    name: 'GenContractorLotsList',
    component: () => import(/* webpackChunkName: "GenContractorLotsList" */ '@/pages/gen-contractor-lots/index.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'GenContractorLotsList');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'GenContractorLotsList');
        store.commit('genContractorLots/setPage', +query.page || 1);
        store.commit('genContractorLots/setSearch', query.search || '');
        store.dispatch('genContractorLots/loadList');
      },
    },
  },
  { // создать лот на ген подряд
    path: '/gen-contractor-lot-request/',
    name: 'GenContractorLotRequest',
    component: () => import(/* webpackChunkName: "GenContractorLotRequest" */ '@/pages/gen-contractor-lots/detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  { // просмотр лота на ген подряд
    path: '/gen-contractor-lot-detail/:id/',
    name: 'GenContractorLotDetail',
    component: () => import(/* webpackChunkName: "GenContractorLotRequest" */ '@/pages/gen-contractor-lots/detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // успешно подали заявку в конкурсе на ген. подряд
  {
    path: '/success/gen-contractor-lot-offer',
    name: 'SuccessGenContractorLotOffer',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/gen-contractor-lots/success-offer.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  { // список актуальных конкурсов на подряды
    path: '/contract-works/',
    name: 'ContractWorksList',
    component: () => import(/* webpackChunkName: "ContractWorksList" */ '@/pages/contract-works/index.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'ContractWorksList');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'ContractWorksList');
        store.commit('contractWorksList/setPage', +query.page || 1);
        store.commit('contractWorksList/setSearch', query.search || '');
        store.commit('contractWorksList/setArchive', false);
        store.dispatch('contractWorksList/loadList');
      },
    },
  },
  { // список архивных конкурсов на подряды
    path: '/contract-works/archive/',
    name: 'ContractWorksListArchive',
    component: () => import(/* webpackChunkName: "ContractWorksList" */ '@/pages/contract-works/index.vue'),
    beforeEnter: () => {
      store.commit('appService/setFilterType', 'ContractWorksListArchive');
    },
    meta: {
      requiresAuth: true,
      deserializeQuery: (query) => {
        store.commit('appService/setFilterType', 'ContractWorksList');
        store.commit('contractWorksList/setPage', +query.page || 1);
        store.commit('contractWorksList/setSearch', query.search || '');
        store.commit('contractWorksList/setArchive', true);
        store.dispatch('contractWorksList/loadList');
      },
    },
  },
  { // просмотр конкурса на подряд
    path: '/contract-works/:id/',
    name: 'ContractWorkDetail',
    component: () => import(/* webpackChunkName: "GenContractorLotRequest" */ '@/pages/contract-works/detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  { // создать конкурс на подряд
    path: '/contract-works/new/',
    name: 'ContractWorkCreate',
    component: () => import(/* webpackChunkName: "GenContractorLotRequest" */ '@/pages/contract-works/detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // успешно подали заявку в конкурсе на подряд
  {
    path: '/contract-works/success-offer/',
    name: 'ContractWorkSuccessOffer',
    component: () => import(/* webpackChunkName: "allPurchases" */ '@/pages/contract-works/success-offer.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
  linkActiveClass: 'aside__submenu-list-link--active',
  routes,
});

router.beforeEach(async (to, from, next) => {
  let saveMe = false;
  let accessToken = localStorage.getItem('accessToken');
  let refreshToken = localStorage.getItem('refreshToken');

  if (accessToken && refreshToken) {
    saveMe = true;
  } else {
    accessToken = sessionStorage.getItem('accessToken');
    refreshToken = sessionStorage.getItem('refreshToken');
  }

  if (accessToken && refreshToken) {
    try {
      const decodedToken = jwtDecode(accessToken);
      const diff = new Date(decodedToken.exp * 1000).getTime() - new Date().getTime();

      if (diff <= 0) {
        await store.dispatch('user/renew');
      } else if (!store.state.user.isLoggedIn) {
        await store.dispatch('user/setAuthData', {
          saveMe,
          access: accessToken,
          refresh: refreshToken,
        });
      }
    } catch (error) {
      console.error('router.beforeEach', error);
    }
  }

  if (to.meta.requiresAuth && !store.state.user.isLoggedIn) {
    next({ name: 'Auth', query: { from: window.location.pathname } });
  } else {
    if (to.meta.requiresAuth) {
      await store.dispatch('user/loadInfo');
    }

    if (!to.params.isSaveParams && to.meta.deserializeQuery) {
      await to.meta.deserializeQuery(to.query);
    }

    next();
  }
});

export default router;
